// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lumen-smile.onrender.com/api';

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

// API endpoints
export const API_ENDPOINTS = {
  // Content endpoints
  websiteContent: '/website-content/',
  services: '/services/',
  doctors: '/doctors/',
  coreValues: '/core-values/',
  whyChooseUs: '/why-choose-us/',
  faqs: '/faq/',
  team: '/team/',
  testimonials: '/testimonials/',
  ourStrengths: '/our-strengths/',
  blog: '/blog/',
  galleryItems: '/gallery/items/',
  galleryCategories: '/gallery/categories/',
  
  // User endpoints
  login: '/users/login/',
  register: '/users/register/',
  userProfile: '/users/me/',
  
  // Contact endpoint
  contactMessages: '/contact-messages/',
  
  // Appointment endpoints
  appointments: '/appointments/',
  doctorAvailability: '/doctor-availability/',
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = getApiUrl(endpoint);
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  
  const response = await fetch(url, { ...defaultOptions, ...options });
  
  if (!response.ok) {
    throw new Error(`API call failed: ${response.status}`);
  }
  
  return response.json();
}; 